import { useState } from "react";
import styled from "styled-components";
import ExpandIcon from "../../../../assets/images/icons/Web_Sprite_Icon_Expand.png";
import X from "../../../../assets/images/buttonIcons/purpleX.png";

const Card = ({ src, label, isVideo = false, alt = "Card media" }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleExpandClick = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <StyledCard>
                {isVideo ? (
                    <FeatureVideo src={src} playsInline controls={false} autoPlay muted loop  />
                ) : (
                    <FeatureImage src={src} alt={alt} />
                )}
                <TextDescription>
                    <CardLabel>{label}</CardLabel>
                    <ExpandIconImage
                        onClick={handleExpandClick}
                        src={ExpandIcon}
                        alt="Expand"
                        role="button"
                        aria-label="Expand media"
                    />
                </TextDescription>
            </StyledCard>

            {isModalOpen && (
                <ModalOverlay onClick={handleCloseModal}>
                    <CloseButtonWrapper>
                        <CloseButton onClick={handleCloseModal}>
                            <CloseText>CLOSE</CloseText>
                            <CloseIcon src={X} alt="Close" />
                        </CloseButton>
                    </CloseButtonWrapper>
                    <ModalContent onClick={(e) => e.stopPropagation()}>
                        {isVideo ? (
                            <ModalVideo src={src} playsInline controls={false} autoPlay loop />
                        ) : (
                            <ModalImage src={src} alt={alt} />
                        )}
                    </ModalContent>
                </ModalOverlay>
            )}
        </>
    );
};

export default Card;

const ExpandIconImage = styled.img`
    width: 24px;
    height: 24px;
    opacity: 0;
    transition: opacity 0.3s ease;
    cursor: pointer;
    z-index: 10;
`;

const StyledCard = styled.div`
    width: auto;
    max-width: 650px;
    height: auto;
    max-height: 450px;
    border-radius: 10px;
    border: 2px solid rgba(190, 174, 255, 0.3);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;

    &:hover ${ExpandIconImage} {
        opacity: 1;
    }

    @media (max-width: 960px) {
        width: 100%;
        max-width: 512px;
    }
`;

const FeatureVideo = styled.video`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const FeatureImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 10px 10px 0 0;
`;

const TextDescription = styled.div`
    height: 20%;
    width: 100%;
    background: transparent;
    backdrop-filter: blur(15px);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    border-radius: 0 0 10px 10px;
`;

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(10px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 10000000000;
`;

const ModalContent = styled.div`
    position: relative;
    width: 80%;
    max-width: 900px;
    max-height: 80vh;
    border-radius: 10px;
    overflow: hidden;
`;

const ModalVideo = styled.video`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

const ModalImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

const CloseButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    width: 80%;
    max-width: 900px;
    padding: 10px;
`;

const CloseButton = styled.button`
    position: relative;
    left: 10px;
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px;
    z-index: 10;
`;

const CloseIcon = styled.img`
    width: 24px;
    height: 24px;

    @media (max-width: 960px) {
        width: 18px;
        height: 18px;
    }
`;

const CardLabel = styled.p`
    color: var(--Text-Primary, #fbfcff);
    leading-trim: both;

    text-edge: cap;
    -webkit-text-stroke-width: 1.11px;
    -webkit-text-stroke-color: rgba(0, 0, 0, 0.5);
    font-family: "Barlow";
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0px;

    @media (max-width: 960px) {
        font-size: 22px;
    }
`;

const CloseText = styled.p`
    color: var(--Purple-Primary, #beaeff);
    leading-trim: both;
    text-edge: cap;
    font-family: "Barlow";
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 2.2px;
    text-transform: uppercase;

    @media (max-width: 960px) {
        font-size: 18px;
    }

    @media (max-width: 960px) {
        font-size: 16px;
    }
`;
